import { useTranslation } from "react-i18next";

const Validation = () => {
  const { t } = useTranslation();
  const nameRegexp = /^[A-Za-zА-Яа-яА-Яа-яËёЄєЇїІі-\s]+$/;
  const emailRegexp = (email) => {
    const re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    return re.test(String(email).toLowerCase());
  };

  const nameValidation = (name) => {
    if (name?.length === 0) {
      return t("enterName");
    } else if (!nameRegexp.test(name)) {
      return t("containLetters");
    }
  };

  const emailValidation = (email) => {
    if (email?.length === 0) {
      return t("enterMail");
    } else if (!emailRegexp(email)) {
      return t("enterCorrectMail");
    }
  };

  const phoneValidation = (phone) => {
    if (nameRegexp.test(phone)) {
      return t("notContainLetters");
    }
  };

  const messageValidation = (message) => {
    if (message?.length === 0) {
      return t("enterText");
    }
  };

  return {
    nameValidation,
    emailValidation,
    phoneValidation,
    messageValidation,
  };
};

export default Validation;
